<template>
  <div />
</template>
<script>
// @ is an alias to /src
import { db } from "@/fstore";
import { addDays } from "date-fns";
import { numberOfTrialDays } from "@/defaults";

export default {
  name: "UserPrefsBinder",
  components: {},
  props: {},
  data() {
    return {};
  },
  computed: {
    user() {
      return this.$store.state.user;
    }
  },
  watch: {},
  mounted() {
    var _v = this;
    // Confirmation only occurs after a successful .get().
    // onSnapshot does not return an error when user is offline.
    // .get() does.
    db.collection("users")
      .doc(this.user.uid)
      .get()
      .then(function(doc) {
        if (doc.exists) {
          console.log("Document data:", doc.data());
          _v.$store.dispatch("setUserDoc", doc.data());
        } else {
          // doc.data() will be undefined in this case
          console.log("No such document!");
        }
        _v.bindAll();
      })
      .catch(function(error) {
        if (error.code == "unavailable") {
          // The service is offline.
          // Show the main offline error.
          _v.$store.commit("setServiceUnavailable", true);
        }
        console.log("Error getting document:", error.code, error.name);
      });
  },
  methods: {
    bindAll() {
      // Only bind after you have confirmation that the user is online.
      var _v = this;
      db.collection("users")
        .doc(this.user.uid)
        .onSnapshot(function(doc) {
          if (doc.exists) {
            var source = doc.metadata.hasPendingWrites ? "Local" : "Server";
            console.log("user_prefs: from", source);
            _v.$store.dispatch("setUserDoc", doc.data());
          } else {
            // Set initial user data here.
            var now_at = new Date().getTime();
            var defaultTrialDays = numberOfTrialDays;
            var trial_expires_at = addDays(now_at, defaultTrialDays).getTime();
            var data = {
              email: _v.user.email,
              uid: _v.user.uid,
              created_at: now_at,
              updated_at: now_at,
              trial_expires_at: trial_expires_at,
              emailListSubscribed: _v.$store.state.initialSignupEmailPreference,
              counter_shows_total: 0
            };
            db.collection("users")
              .doc(_v.user.uid)
              .set(data, { merge: true });
            // Then bind.
            db.collection("users")
              .doc(_v.user.uid)
              .onSnapshot(function(doc) {
                var source = doc.metadata.hasPendingWrites ? "Local" : "Server";
                console.log("user_prefs: from", source);
                _v.$store.dispatch("setUserDoc", doc.data());
              });
          }
        });

      // Show index.
      db.collection("user_show_index")
        .doc(this.user.uid)
        .onSnapshot(function(doc) {
          if (doc.exists) {
            var source = doc.metadata.hasPendingWrites ? "Local" : "Server";
            console.log("user_show_index: from", source);
            _v.$store.commit("set_user_show_index", doc.data());
          } else {
            _v.$store.commit("set_user_show_index", {});
          }
        });
    }
  }
};
</script>
